import hero1 from '../assest/caro/23.webp';
import hero2 from '../assest/caro/4.webp';
import hero3 from '../assest/caro/15.webp';
import hero4 from '../assest/caro/13.webp';
import hero5 from '../assest/caro/1.webp';
import hero6 from '../assest/caro/17.webp';
import hero7 from '../assest/caro/18.webp';
import hero8 from '../assest/caro/20.webp';
import hero9 from '../assest/caro/21.webp';
import hero10 from '../assest/caro/2.webp';
import hero11 from '../assest/caro/3.webp';
import hero12 from '../assest/caro/10.webp';
import hero13 from '../assest/caro/24.webp';
import hero14 from '../assest/caro/25.webp';
import hero15 from '../assest/caro/22.webp';
import hero16 from '../assest/caro/16.webp';
import hero17 from '../assest/caro/19.webp';
import hero18 from '../assest/caro/4.webp';
import hero19 from '../assest/caro/11.webp';
import hero20 from '../assest/caro/12.webp';
import hero21 from '../assest/caro/8.webp';
import hero22 from '../assest/caro/7.webp';
import hero23 from '../assest/caro/5.webp';
import hero24 from '../assest/caro/6.webp';

import ablum1 from '../assest/album/a8.webp';
import ablum2 from '../assest/album/a2.webp';
import ablum3 from '../assest/album/a3.webp';
import ablum4 from '../assest/album/a4.webp';
import ablum5 from '../assest/album/a5.webp';
import ablum6 from '../assest/album/a6.webp';
import ablum7 from '../assest/album/a7.webp';
import ablum8 from '../assest/album/a1.webp';
import ablum9 from '../assest/album/a9.webp';
import ablum10 from '../assest/album/a10.webp';
import ablum11 from '../assest/album/a11.webp';
import ablum12 from '../assest/album/a12.webp';



export const sec2 = Object.freeze({
  heading: "Abi Wickramarathna Photography",
  heading2: "Galleries",
  heading3: "Let's Talk ",
  des1: "I believe every moment has a story—and my passion is capturing those stories in the most authentic and timeless way. Whether it’s a wedding, pre-shoot, bridal portrait, fashion session, or a special celebration, I focus on preserving real emotions, natural expressions, and the true essence of your day.",
  des2: "Unlike ordinary event photography, my style is built around candid moments, soft natural lighting, and genuine interactions. I aim to create images that feel real, warm, and full of life—so when you look back at your photos years later, you can relive every laugh, tear, and memory as if it happened yesterday.",
  des3: "With dedication, creativity, and an eye for detail, I make sure your special moments are beautifully framed and artistically captured. From intimate love stories to grand celebrations, I am here to turn your memories into everlasting visuals that you and your loved ones will treasure for generations.",
  des4: "Explore our albums—where every photo reveals a memory, and every memory becomes a timeless story.",
  des5: "Let's create something beautiful together!",

});

export const linkss = Object.freeze({
  fbpage: "https://web.facebook.com/abicaptures"
});

export const caroSlide = [
  {
    image: (hero1),
  },
  {
    image: (hero2),
  },
  {
    image: (hero3),
  },
  {
    image: (hero4),
  },
  {
    image: (hero5),
  },
  {
    image: (hero6),
  },
  {
    image: (hero7),
  },
  {
    image: (hero8),
  },
  {
    image: (hero9),
  },
  {
    image: (hero10),
  },
  {
    image: (hero11),
  },
  {
    image: (hero12),
  },
  {
    image: (hero13),
  },
  {
    image: (hero14),
  },
  {
    image: (hero15),
  },
  {
    image: (hero16),
  },
  {
    image: (hero17),
  },
  {
    image: (hero18),
  },
  {
    image: (hero19),
  },
  {
    image: (hero20),
  },
  {
    image: (hero21),
  },
  {
    image: (hero22),
  },
  {
    image: (hero23),
  },
  {
    image: (hero24),
  },

  {
    image: (hero1),
  },
  {
    image: (hero2),
  },
  {
    image: (hero3),
  },
  {
    image: (hero4),
  },
  {
    image: (hero5),
  },
  {
    image: (hero6),
  },
  {
    image: (hero7),
  },
  {
    image: (hero8),
  },
  {
    image: (hero9),
  },
  {
    image: (hero10),
  },
  {
    image: (hero11),
  },
  {
    image: (hero12),
  },
  {
    image: (hero13),
  },
  {
    image: (hero14),
  },
  {
    image: (hero15),
  },
  {
    image: (hero16),
  },
  {
    image: (hero17),
  },
  {
    image: (hero18),
  },
  {
    image: (hero19),
  },
  {
    image: (hero20),
  },
  {
    image: (hero21),
  },
  {
    image: (hero22),
  },
  {
    image: (hero23),
  },
  {
    image: (hero24),
  },

];

export const photoAlbum = [
  {
    image: (ablum1),
    title: "Hazara",
    url: "https://photos.app.goo.gl/RLGDQiQb64j16CtZA"
  },
  {
    image: (ablum2),
    title: "Mashi",
    url: "https://photos.app.goo.gl/UFp6zvCveS7NgQTEA"
  },
  {
    image: (ablum3),
    title: "shinuka",
    url: "https://photos.app.goo.gl/oTAABcg4J8WE4xEGA"
  },
  {
    image: (ablum4),
    title: "Hazara",
    url: "https://photos.app.goo.gl/ae7fLL9xspSEakSUA"
  },
  {
    image: (ablum5),
    title: "Flora",
    url: "https://photos.app.goo.gl/XnFgFG9fHCLh7uQy5"
  },
  {
    image: (ablum6),
    title: "Dedunu",
    url: "https://photos.app.goo.gl/jsuC5excyHMwg3Ei9"
  },
  {
    image: (ablum7),
    title: "Yaara",
    url: "https://photos.app.goo.gl/5JNWbbwomcN8kWCSA"
  },
  {
    image: (ablum8),
    title: "Ruwini",
    url: "https://photos.app.goo.gl/48rVJzy9d9UhcBYEA"
  },
  {
    image: (ablum9),
    title: "Imasha",
    url: "https://photos.app.goo.gl/61hE9k1jrzRYxgFj6"
  },
  {
    image: (ablum10),
    title: "Kavishka",
    url: "https://photos.app.goo.gl/xFV7SL1Zxz4M44Cj8"
  },
  {
    image: (ablum11),
    title: "Pasindi",
    url: "https://photos.app.goo.gl/8RLenD67Jvbh234v6"
  },
  {
    image: (ablum12),
    title: "Hasindu",
    url: "https://photos.app.goo.gl/mbydKmD6f1JrcgkH7"
  },
]